import axiosInstance from './axiosInstance';

const profilApi = {
    // fetchUserData: (email) => axiosInstance.post('/profile/userdata', { email }),
    fetchUserData: (email, userId) => axiosInstance.post('/profile/usersubscription', { email, userId }),
    getTestLimit: (userId, email) => axiosInstance.post('/user/test-limit', { userId, email }),
    unbindUser: (email) => axiosInstance.post('/profile/unbind', { email }),
    updateAutoPayment: (email, enable) => axiosInstance.post('/profile/updateAutoPayment', { email, enable }),
    updateProfile: (data) => axiosInstance.put('/profile/update-profile', data, {
        headers: {
            "Content-Type": "multipart/form-data"
        }
    }),

};

export default profilApi;